import {Component, Host, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormGroupDirective, Validators} from '@angular/forms';
import {SelectItem} from 'primeng/api';
import {getStatusBackgroundColour, getStatusColour} from '../../../lookups/statuses';
import {Order} from '../../../models/order.model';
import {ProposedMessage} from '../../../models/proposedMessage.model';

@Component({
  selector: 'app-high-user[message][order][isSmallerThanLarge][messageTypes]',
  templateUrl: './high-user.component.html',
  styleUrls: ['./high-user.component.scss']
})
export class HighUserComponent implements OnInit {

  constructor(
    @Host() private parentFormDirective: FormGroupDirective,
  ) { }
  @Input() message: ProposedMessage;
  @Input() order: Order;
  @Input() isSmallerThanLarge: boolean;
  @Input() messageTypes: SelectItem<string>[];
  highUserMessageTypes: SelectItem<string>[];

  getStatusColour = getStatusColour;
  getStatusBackgroundColour = getStatusBackgroundColour;

  ngOnInit() {
    if (this.message.messageType == 'High User') {
      this.messageForm.addControl('messageToSend', new FormControl('', Validators.required));
      this.highUserMessageTypes = this.messageTypes.filter((selectItem: SelectItem<string>) =>
        selectItem.value.startsWith('High User -')
      );  
    }
  }

  get messageForm(): FormGroup {
    return this.parentFormDirective.form;
  }
}
